(function () {
  const initProductAccordion = () => {
    document.querySelectorAll('.about__accordion-toggle').forEach(toggle => {
      toggle.addEventListener('click', function () {
        const desc = this.parentElement.querySelector('.about__accordion-description');
        if (!this.classList.contains('active')) {
          this.classList.add('active');
          if (desc) { desc.style.display = 'block'; }
        } else {
          this.classList.remove('active');
          if (desc) { desc.style.display = 'none'; }
        }
      });
    });
  };

  document.addEventListener('shopify:section:load', initProductAccordion);
  initProductAccordion();
})();
